import React, { useRef, useEffect } from "react";
import { Col, Row, Container } from "reactstrap";
import { Figure } from "react-bootstrap";
import cn from "classnames";

export default function HubSpotForm({
  global,
  pathPrefix,
  customClass,
  title,
  description,
  image,
  imageAlt,
  imageSize = "603x584",
  form_src, // Prop for HubSpot form script URL
  form_id,
  url_slug, // Prop for HubSpot form ID
}) {
  const formContainerRef = useRef(null);
  const formScriptInit = useRef(false);

  useEffect(() => {
    if (formScriptInit.current) return;

    // Dynamically load the HubSpot form script
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "//js-eu1.hsforms.net/forms/embed/v2.js"; // Use the provided form_src URL (HubSpot)
    script.async = true; // Ensure the script loads asynchronously to avoid blocking
    script.onload = () => {
      // Once the script is loaded, explicitly initialize the HubSpot form
      if (window.hbspt) {
        const escapedId = form_id.match(/^\d/)
          ? `\\3${form_id[0]} ${form_id.slice(1)}`
          : form_id;
        window.hbspt.forms.create({
          portalId: "26198844",
          formId: form_id,
          target: `#${escapedId}`,
          onFormSubmit: () => {
            window.scrollTo({ top: window.innerHeight * 0.4, behavior: "smooth" });
          },
        });
      }
    };

    formContainerRef.current.appendChild(script);
    formScriptInit.current = true;
  }, [form_src, form_id]);

  return (
    <>
      <section className={cn(customClass, "mt-5")}>
        <Container>
          <div className="hbspt-form" id={form_id} ref={formContainerRef}></div>
        </Container>
      </section>
    </>
  );
}
